import { useEffect, useState } from 'react'

import { breakpoints } from '~/assets/styles'

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window
  const xs = width <= breakpoints.xs
  const sm = width >= breakpoints.sm
  const md = width >= breakpoints.md
  const lg = width >= breakpoints.lg
  const xl = width >= breakpoints.xl
  const xxl = width >= breakpoints.xxl

  return {
    width,
    height,
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
  }
}

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}
